<template>
	<div v-on:click="$emit('click')" class="flag">

		<svg v-if="getCountry() == 'dk'" :style="style" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
			<path style="fill:#FF4B55;" d="M473.655,423.724H38.345C17.167,423.724,0,406.557,0,385.379V126.621  c0-21.177,17.167-38.345,38.345-38.345h435.31c21.177,0,38.345,17.167,38.345,38.345V385.38  C512,406.557,494.833,423.724,473.655,423.724z"/>
			<polygon style="fill:#F5F5F5;" points="512,229.517 211.862,229.517 211.862,88.276 158.897,88.276 158.897,229.517 0,229.517   0,282.483 158.897,282.483 158.897,423.724 211.862,423.724 211.862,282.483 512,282.483 "/>
		</svg>

		<svg v-if="getCountry() == 'se'" :style="style" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
			<path style="fill:#4173CD;" d="M473.655,88.275H38.345C17.167,88.275,0,105.442,0,126.62V385.38  c0,21.177,17.167,38.345,38.345,38.345h435.31c21.177,0,38.345-17.167,38.345-38.345V126.62  C512,105.442,494.833,88.275,473.655,88.275z"/>
			<polygon style="fill:#FFE15A;" points="512,229.516 211.862,229.516 211.862,88.275 158.897,88.275 158.897,229.516 0,229.516   0,282.482 158.897,282.482 158.897,423.724 211.862,423.724 211.862,282.482 512,282.482 "/>
		</svg>

		<svg v-if="getCountry() == 'nl'" :style="style" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512"  style="border-radius: 40%" xml:space="preserve">
			<rect y="85.337" style="fill:#ad1c28" width="512" height="341.326"/>
			<rect y="198" style="fill:#fff" width="512" height="113.775"/>
			<rect y="312.888" style="fill:#21468b" width="512" height="113.775"/>
		</svg>

		<svg v-if="getCountry() == 'de'" :style="style" enable-background="new 0 0 64 64" version="1.1" viewBox="0 0 64 64" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Flag40"/><g id="Flag39"/><g id="Flag38"/><g id="Flag37"/><g id="Flag36"/><g id="Flag35"/><g id="Flag34"/><g id="Flag33"/><g id="Flag32"/><g id="Flag31"/><g id="Flag30"/><g id="Flag29"/><g id="Flag28"/><g id="Flag27"/><g id="Flag26"/><g id="Flag25"/><g id="Flag24"/><g id="Flag23"/><g id="Flag22"/><g id="Flag21"/><g id="Flag20"><g><rect fill="#333333" height="12" width="60" x="2" y="14"/><path d="M62,27H2c-0.5527,0-1-0.4478-1-1V14c0-0.5522,0.4473-1,1-1h60c0.5527,0,1,0.4478,1,1v12    C63,26.5522,62.5527,27,62,27z M3,25h58V15H3V25z" fill="#414042"/></g><g><rect fill="#FFB132" height="12" width="60" x="2" y="38"/><path d="M62,51H2c-0.5527,0-1-0.4478-1-1V38c0-0.5522,0.4473-1,1-1h60c0.5527,0,1,0.4478,1,1v12    C63,50.5522,62.5527,51,62,51z M3,49h58V39H3V49z" fill="#414042"/></g><g><rect fill="#D34A4B" height="12" width="60" x="2" y="26"/><path d="M62,39H2c-0.5527,0-1-0.4478-1-1V26c0-0.5522,0.4473-1,1-1h60c0.5527,0,1,0.4478,1,1v12    C63,38.5522,62.5527,39,62,39z M3,37h58V27H3V37z" fill="#414042"/></g></g><g id="Flag19"/><g id="Flag18"/><g id="Flag17"/><g id="Flag16"/><g id="Flag15"/><g id="Flag14"/><g id="Flag13"/><g id="Flag12"/><g id="Flag11"/><g id="Flag10"/><g id="Flag09"/><g id="Flag08"/><g id="Flag07"/><g id="Flag06"/><g id="Flag05"/><g id="Flag04"/><g id="Flag03"/><g id="Flag02"/><g id="Flag01"/></svg>

	</div>
</template>

<script>

/**
	 * ICONS:
	 *
	 * https://www.iconfinder.com/iconsets/ensign-11
	 */

export default {
  props: [
    'country',
    'size',
    'localeid',
    'countryid',
    'currency'
  ],
  computed: {
    style () {
      const height = this.size ? this.size : 24
      const width = height * 1.2
      return 'width: {w}px; height: {h}px;'.replace('{h}', height).replace('{w}', width)
    }
  },
  methods: {
    getCountry () {
      if (this.country) {
        return this.country
      }

      if (this.currency) {
        switch (this.currency) {
          case 'DKK':
            return 'dk'
          case 'SEK':
            return 'se'
          case 'EUR':
            return 'nl'
        }
      }

      if (this.localeid) {
        switch (Number(this.localeid)) {
          case 1:
            return 'dk'
          case 2:
            return 'se'
          case 3:
            return 'nl'
          case 4:
            return 'de'
        }
      }

      if (this.countryid) {
        switch (Number(this.countryid)) {
          case 1:
            return 'dk'
          case 2:
            return 'se'
          case 3:
            return 'nl'
          case 4:
            return 'de'
        }
      }
    }
  }
}
</script>
